// Turn an API/network error into a clear, friendly, actionable message.
export function authError(err: any, fallback = 'Something went wrong. Please try again.'): string {
  // No response = network/connectivity issue
  if (!err?.response) {
    if (err?.code === 'ECONNABORTED') return 'The request timed out. Check your connection and try again.';
    return 'Network error - please check your internet connection and try again.';
  }
  const status = err.response.status;
  const d = err.response.data || {};

  // Specific backend flags
  if (d.userExists) return 'An account with this phone number already exists. Please log in instead.';
  if (d.needsSignUp) return 'No account found for this number. Please sign up first.';
  if (d.error === 'suspended') return d.message || 'Your account has been suspended. Please contact customer care.';

  // Status-based fallbacks
  if (status === 429) return 'Too many attempts. Please wait a moment and try again.';
  if (status === 401) return d.error || d.message || 'Invalid or expired code. Please try again.';
  if (status === 409) return d.error || d.message || 'That already exists.';
  if (status >= 500) return 'Our servers are having a moment. Please try again shortly.';

  return d.error || d.message || fallback;
}
